import { Notification } from "@/types";
import { useSuspensePaginatedQuery, UseSuspensePaginatedQueryOptions } from "@/utils/query";

export const useNotifications = (
  projectId: string,
  options: Omit<UseSuspensePaginatedQueryOptions<Notification>, "queryKey" | "url">,
) => {
  return useSuspensePaginatedQuery<Notification>({
    queryKey: ["projects", projectId, "notifications"],
    url: `/projects/${projectId}/notifications`,
    ...options
  });
};
